import { BLOG_TRANSLATION_LANGUAGES } from '../utils/blogTranslations.js';

const BLOG_SLUGS = [
  'microstock-workflow-guide',
  'content-discoverability-intent-keywords',
  'shutterstock-keyword-strategy-mistakes',
  'adobe-stock-keyword-order-guide',
  'getty-images-istock-controlled-vocabulary-explained',
  'xmp-vs-iptc-vs-csv-for-stock-photo-uploads',
  'how-to-review-ai-metadata-before-batch-export',
  'market-intelligence-intro',
  'metadata-generator-adobe-stock-product-hunt',
  'metadata-signals-2026',
  'transparent-png-metadata-sales',
  'isolated-asset-metadata-checklist',
  'png-metadata-workflow',
  'ai-cutout-metadata-qc',
  'stock-trends-2026-metadata',
  'metadata-advantage-2026',
  'rights-releases-risk-2026',
  'stock-photo-metadata-2026',
  'metadata-system-2026',
  'free-stock-photo-keyword-generator-guide',
  'stock-photo-keyword-generator-plus',
  'visual-content-renaissance-2026'
];

// Which /<language>/blog/<slug> pages are prerendered for the static posts.
// The sitemap, prerender and hreflang read the full translation maps through
// getBlogAvailableLanguagesForPost(post, BLOG_STATIC_TRANSLATION_MAPS); those
// maps are several megabytes, so the edge middleware and the main client bundle
// read this small mirror instead. scripts/localization-wave-regression.mjs fails
// the build whenever the two disagree.
//
// Every slug in BLOG_SLUGS has a translation in each BLOG_TRANSLATION_LANGUAGES
// language, except the posts listed here with the languages they do have.
export const BLOG_PARTIAL_TRANSLATION_LANGUAGES = Object.freeze({
  'getty-images-istock-controlled-vocabulary-explained': Object.freeze(['bn', 'hi', 'pt']),
  'xmp-vs-iptc-vs-csv-for-stock-photo-uploads': Object.freeze(['bn', 'hi', 'pt']),
  'how-to-review-ai-metadata-before-batch-export': Object.freeze(['bn', 'hi', 'pt'])
});

const BLOG_SLUG_SET = new Set(BLOG_SLUGS);

// Non-English languages with a prerendered static translation of `slug`.
// Firestore (BlogBot) posts are not static and return [] here: they are
// published in English, and their translations, if any, live in Firestore.
export const getStaticBlogTranslationLanguages = (slug) => {
  const normalizedSlug = String(slug || '').trim();
  if (!BLOG_SLUG_SET.has(normalizedSlug)) return [];
  return [...(BLOG_PARTIAL_TRANSLATION_LANGUAGES[normalizedSlug] || BLOG_TRANSLATION_LANGUAGES)];
};

export default BLOG_SLUGS;
